module.exports = __webpack_public_path__ + "img/slots-logo-header.211b1485.png";